import {displayLabel, uiText} from "../utils/videoLanguage";
// Top-level section selector. A 2-column grid (2x2 for the four sections) so
// the buttons stack instead of scrolling sideways on mobile; a single row on
// desktop where there's room.
const SectionNav = ({sections, selectedId, onSelect, language}) => {
  if (!sections || sections.length === 0) return null;
  return (
    <div
      role="tablist"
      aria-label={uiText("Video sections", language)}
      className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-4"
    >
      {sections.map((s) => {
        const active = s.id === selectedId;
        return (
          <button
            key={s.id}
            role="tab"
            aria-selected={active}
            onClick={() => onSelect(s.id)}
            className={`flex items-center justify-center gap-2 px-4 py-3 rounded-2xl font-medium text-sm transition-all border shadow-sm ${active ? "bg-[#191919] text-white border-[#191919]" : "bg-[#F8FAFC] text-[#191919] border-bg-[#F8FAFC] hover:border-slate-300"}`}
          >
            <span className="text-lg shrink-0">{s.icon}</span>
            <span className="whitespace-nowrap">
              {displayLabel(s.title, language)}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default SectionNav;
